import { render } from "./share-modal-settings-link.vue?vue&type=template&id=14a4935e&scoped=true&ts=true"
import script from "./share-modal-settings-link.vue?vue&type=script&lang=ts"
export * from "./share-modal-settings-link.vue?vue&type=script&lang=ts"

import "./share-modal-settings-link.vue?vue&type=style&index=0&id=14a4935e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a4935e"]])

export default __exports__